import React from 'react'
import { Link } from 'react-router-dom'
import { isAuthenticated, logout, isAuthorized } from '../../services/self'
import SignIn from '../../components/SignIn'
import Register from '../../components/Register'
import logo from '../../Nlogo.png'
import csharp from '../../images/csharp.jpg'
import java from '../../images/java.png'
import js from '../../images/js.png'
import auth from '../../images/authModel.png'
import hardhat from '../../images/hardhat.png'


export default class CaseStudies extends React.Component{

  logout() {
    logout()
    this.setState({ loggedOut: true })
  }




render() {
  return(
  <div>

      <div className="Logo">
        <Link className="home-link2" to='/'><img src={logo} className="App-logo" alt="logo" /></Link>
        <Link className="home-link" to='/'>Developer</Link>
      </div>

      <div className="Navbar-Div">
        <nav className="App-navbar">
        <Link className="Centered-link" to='/updates'>Updates</Link>
        <Link className="Centered-link" to='/getting-started'>Getting Started</Link>
        <Link className="Centered-link" to='/documentation'>Docs</Link>
        <Link className="Centered-link" to='/tools'>Tools</Link>
        <Link className="Centered-link" to='/community'>Community</Link>


        <div className="right">
          {isAuthenticated() ? (<Link to='/account'>Account</Link>) : ''}
          {isAuthenticated() ? (<Link to='' onClick={() => this.logout()}>Log out</Link>) : ''}
        </div>

            {isAuthenticated() ? '' : (
              <span className="right">
                <SignIn className="right" />
                <Register className="right-link" />
              </span>
            )}
        </nav>
      </div>

      <div className="App-banner">
        <span className="orange-bold">  NEWFORMA CONNECTED </span> 
      </div>


<div className="content2">

    {/*  <div className="content-wrap-no-padding"> */}

      <div className="left-col">
      <h1 className="left-col-heading">Overview</h1>
      <ul className="left-col-ul">
        <li><a className="doc-link-welcome" href="#introduction">Welcome!</a></li>
        <li><a className="doc-link" href="#whatsnew">What's New?</a></li>
        <li><a className="doc-link" href="#lifecycle">API Lifecycle</a></li>
        <li><a className="doc-link" href="#status">API Status</a></li>
        <li><a className="doc-link" href="#SDK">SDKs</a></li>
        <li><a className="doc-link" href="#faq">FAQ</a></li>
      </ul>
      <h1 className="left-col-heading-lower">Standards</h1>
      <ul className="left-col-lower-ul">
        <li><a className="doc-link" href="#apiGuide">API Guide</a></li>


        <li><a className="doc-link" href="#authentication">Authentication</a></li>
        <li><a className="doc-link" href="#support">Support</a></li>
        <li><a className="doc-link" href="#features">Features</a></li>
        <li><a className="doc-link" href="#nomenclature">Conventions</a></li>
      </ul>


      <h1 className="left-col-heading-lower">Categories</h1>
      <h1 className="left-col-heading-lower-sub">Project Center</h1>

      <ul className="left-col-lower-ul-sub">
      <li><Link className='doc-link' to='/projectctradmin'>Admin API</Link></li>
      <li><Link className='doc-link' to='/reference'>Newforma Enterprise API</Link></li>
      <li><Link className='doc-link' to='/nlreference'>Web/Mobile API</Link></li>
      </ul>

      <h1 className="left-col-heading-lower-sub">ConstructEx</h1>

      <ul className="left-col-lower-ul-sub">
      <li><Link className='doc-link' to='/constructexadmin'>Admin API</Link></li>
      { isAuthorized() ? (<li><Link className='doc-link' to='/constructexapi'>ConstructEx API Reference</Link></li>) : '' }
      </ul>

      <h1 className="left-col-heading-lower-sub">Legacy</h1>

      <ul className="left-col-lower-ul-sub">
      <li><Link className='doc-link' to='/referencelegacy'>Legacy API</Link></li>
      </ul>




      </div>

      <div className="right-col">

      <h1 className="introduction-header-welcome">Welcome!</h1>
      <div className="targetHelper" id="introduction"></div>
      <hr className="short-hr"></hr>
      <p className="introduction-p">
        Welcome to the Newforma Developer Portal! This site is a repository of all our technical documentation for Newforma Connect which contains all of Newforma's APIs, SDKs,
        sample code, guides and more.
        Newforma is a software innovation company that provides comprehensive solutions to the Architecture, Engineering, and Construction industries as well as to building
        owners. To get started with our open Application Programming Interface (API) visit the <Link className='home-link2' to='/getting-started'>Getting Started</Link> section
        which will guide you through setting up authentication and then your first Newforma API "Hello World" app, which will do a lot more than just say hello to the world.
      </p>
      <p className="introduction-p">
          Newforma's APIs empower Developers to gain more value out of our software by:
      </p>

      <ul className="docs-ul">
          <li>Building an integration with our award winning software.</li>

          <li>Implementing automated processes for everyday functions.</li>

          <li>Designing and developing an app that uses any number of powerful combinations of our workflows.</li>
      </ul>
      <h1 className='sub-introduction-header'>Newforma RESTful API</h1>
      <p className="introduction-p">
        It is Newforma's intent to provide a robust set of open API endpoints to our customers, partners and new developers. These endpoints will place within your grasp
        a powerful tool to leverage the already existent data in new creative and innovative ways. Our API Team has put in a lot of effort for our customers to ensure that
        the API endpoints we have developed will allow you to access the data you need.
      </p>



{/*-----------What's New?------------------------ */}
      <hr className="full-hr" ></hr>

      <h1 className="introduction-header" >What's New?</h1>
      <div className="targetHelper" id="whatsnew"></div>
      <hr className="short-hr"></hr>

    {isAuthorized() ? ( <div> <p className="newTag"><span className="orange">*NEW</span></p>
      <p className="introduction-p">
      Newforma has a brand new category of API endpoints avaiable for our ContructEx product. You will now be able to authenticate via an API and gain access to
      Projects and Submittals. Our team has crafted these endpoints so that you can push Submittals into ConstuctEx as well as pull them into other systems.
    </p> </div>) : ''}

      <p className="introduction-p">
        Newforma's recently released RESTful APIs now have an exciting new category, Newforma Enterprise APIs designed for ERP/CRM
        (Enterprise Resource Planning/Customer Relationship Management). With this new set of APIs you can automate the process of creating,
        managing and updating projects in Newforma Project Center. In addition to projects this new category exposes access to the project team
        activity granting you powerful tools to update and maintain all your projects' team members. These new APIs are currently in the Beta stage
        and not yet available in production. We have already made available the reference documentation to allow you to start planning how these APIs will
        help your company or integration.
      </p>


{/*-----------API Lifecycle------------------------ */}
      <hr className="full-hr" ></hr>

      <h1 className="introduction-header" >API Lifecycle</h1>
      <div className="targetHelper" id="lifecycle"></div>
      <hr className="short-hr"></hr>

      <p className="introduction-p">
        Newforma's APIs will go through a standardized lifecycle from creation to deprecation. These stages will be development, pre-production and
        production. Any current or future set of APIs will be versioned following semantic versioning. To better understand the lifecycle and versioning read
        through more detailed sections below.
      </p>

        <h1 className='sub-introduction-header'>Lifecycle</h1>

        <ul className="docs-ul">
            <li><span className="lifecycle-bold">Development: </span> while in the development stage API resources will be considered to be in an alpha
          status. While in the alpha status documentation and reference regarding these resources will be available via the development portal but will
        be subject to change.</li>

            <li><span className="lifecycle-bold">Pre-Production: </span> while in the pre-production stage API resources will be considered to be in a beta
          status. While in the beta status documentation and references will no longer change though we will reserve the option to make last minute changes. If
          last minute changes are made this will be communicated in the Updates section of the website.
          Also while in this stage upon request testing of these endpoints will be available.</li>

            <li><span className="lifecycle-bold">Production: </span> once resources have been released to production documentation and references will no longer be
          subject to change. At this stage resources will be made widely available for use.</li>
        </ul>


        <h1 className='sub-introduction-header'>Versioning</h1>

        <p className="introduction-p">
          All current and future releases of Newforma APIs including but not limited to NPC will be in the form of <span className="majorMinorPatch">MAJOR.MINOR.PATCH</span> .
        </p>

        <ul className="docs-ul">
            <li><span className="majorMinorPatch">MAJOR</span> will indicate the new APIs include breaking changes.</li>

            <li><span className="majorMinorPatch">MINOR</span> will indicate the new APIs new functionality that will not break an existing APIs.</li>

            <li><span className="majorMinorPatch">PATCH</span> will indicate when a bug has been identified and squashed.</li>
        </ul>




{/*-----------API STATUS------------------------ */}
      <hr className="full-hr"></hr>

      <h1 className="introduction-header">API Status</h1>
      <div className="targetHelper" id="status"></div>
      <hr className="short-hr"></hr>

      <span className="introduction-span">
      <table className="api-status-table">
      <tbody>
        <tr>
          <th>Newforma Enterprise API Endpoint</th>
          <th>Version</th>
          <th>Status</th>
        </tr>

        <tr>
          <td>/Companies</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>
        <tr>
          <td>/CompanyOfficeLocations</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>
        <tr>
          <td>/Contacts</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>
        <tr>
          <td>/EdmsPlugins</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>
        <tr>
          <td>/Health</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>
        <tr>
          <td>/KeywordListAssignments</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>
        <tr>
          <td>/Keywords</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>
        <tr>
          <td>/OfficeLocations</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>

        <tr>
          <td>/Projects</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>

        <tr>
          <td>/ProjectTeamMembers</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>
        <tr>
          <td>/ProjectCompanyRoles</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>
        <tr>
          <td>/ProjectFolders</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>
        <tr>
          <td>/Search</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>
        <tr>
          <td>/Submittals</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>
        <tr>
          <td>/Transmittals</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>
        <tr>
          <td>/User</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>
        <tr>
          <td>/Version</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>

        </tbody>
      </table>

      <div className="status-table-space"></div>


      <table className="api-status-table">
      <tbody>
        <tr>
          <th>Web/Mobile API Endpoint</th>
          <th>Version</th>
          <th>Status</th>
        </tr>

        <tr>
          <td>/Login</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>

        <tr>
          <td>/ActionItems</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>

        <tr>
          <td>/accessKeys</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>

        <tr>
          <td>/configurations</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>

        <tr>
          <td>/domains</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>

        <tr>
          <td>/email</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>

        <tr>
          <td>/events</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>



        <tr>
          <td>/Files</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>

        <tr>
          <td>/FileTypes</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>

        <tr>
          <td>/idp-configurations</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>

        <tr>
          <td>/Login</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>

        <tr>
          <td>/Preview</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>

        <tr>
          <td>/ProjectEmail</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>

        <tr>
          <td>/Projects</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>

        <tr>
          <td>/Search</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>

        <tr>
          <td>/SharedFolders</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>

        <tr>
          <td>/SharedItems</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>


        </tbody>

      </table>

  <div className="status-table-space"></div>

    { isAuthorized() ?  (<table className="api-status-table">
        <tr>
          <th>ConstructEx API Endpoint</th>
          <th>Version</th>
          <th>Status</th>
        </tr>

        <tr>
          <td><span className="tableDataLeftAlign">*NEW</span>/Auth/Tokens</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>

        <tr>
          <td><span className="tableDataLeftAlign">*NEW</span>/Projects</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>

        <tr>
          <td><span className="tableDataLeftAlign">*NEW</span>/Submittals</td>
          <td>1.0</td>
          <td>Production</td>
        </tr>


      </table>) : ''}
      </span>

{/*-----------SDKs------------------------ */}

<hr className="full-hr"></hr>

<h1 className="introduction-header">SDKs</h1>
<div className="targetHelper" id="SDK"></div>
<hr className="short-hr"></hr>


<p className="introduction-p"><img alt="comingSoon" className="comingSoon" src={hardhat}/>Coming Soon!<img alt="comingSoon" className="comingSoon" src={hardhat}/></p>
<p className="introduction-p">
  Newforma SDKs that will make your integration with us easier. Please check back to download our SDKs for the languages below.
</p>



<table className="languages-table">
<tbody>
  <tr>
    <td><img className="language-icon" alt="csharpIcon" src={csharp}></img></td>
    <td><img className="language-icon" alt="javaIcon" src={java}></img></td>
    <td><img className="language-icon" alt="javaScriptIcon" src={js}></img></td>
  </tr>
</tbody>
</table>




{/*-----------API Guide------------------------ */}

      <hr className="full-hr"></hr>

      <h1 className="introduction-header" >API Guide to RESTful Concepts</h1>
      <div className="targetHelper" id="apiGuide"></div>
      <p className="introduction-p-italic">
      "Elementary, my dear Watson."
      </p>
      <hr className="short-hr"></hr>

      <p className="introduction-p">
      If you are brand new to the world of APIs please read through this section for a brief overview of what they are and how they can be useful.
      </p>
      <h1 className='sub-introduction-header'>Overview</h1>
      <p className="introduction-p">
        An API or application programming interface  can be thought of as the rules or features of software that allow interaction with resources belonging to
        that software in a generic way typically interacting with other software or hardware. This would be similar to a brick and mortar library. The client software
        or book borrower that wishes to borrow a book submits a request to the librarian(the API) which takes the request gathers the requested resource and returns it with
        a success message (HTTP 200 OK) to the borrower. The borrower then takes the resource and parses it into their desired format, perhaps a book report.
      </p>
      <p className="introduction-p">
        "REST" enters this scenario as the literal description of the transfer. REST or representational state transfer is not a particular type of technology instead
        should be considered a data architecture and design methodology. REST is used to produce predictable and consistent output. It does this by receiving a standard
        set of verbs(GET, PUT, POST, DELETE) and returning data in a standard structure such as JSON or XML, representing the resource, which in the above scenario would
        be the book.
      </p>

      <table className="verbs-table">
      <tbody>
        <tr>
          <th>Verb</th>
          <th>Purpose</th>
        </tr>
        <tr>
          <td className="resource-td-width">GET</td>
          <td>
            Retrieving records
          </td>
        </tr>
        <tr>
          <td className="resource-td-width">POST</td>
          <td>
            Creating records
          </td>
        </tr>
        <tr>
          <td className="resource-td-width">PUT</td>
          <td>
            Replacing records
          </td>
        </tr>
        <tr>
          <td className="resource-td-width">PATCH</td>
          <td>
            Updating records
          </td>
        </tr>
        <tr>
          <td className="resource-td-width">OPTIONS</td>
          <td>
            Retrieve endpoint's accepted options
          </td>
        </tr>
        <tr>
          <td className="resource-td-width">DELETE</td>
          <td>
            Deleting records
          </td>
        </tr>
        </tbody>
      </table>

      <h1 className='sub-introduction-header'>HTTP Response Codes</h1>
      <p className="introduction-p">
        Each time you send a request to Neforma's APIs you will be making an HTTP formatted request. For each request you will see an HTTP status code to let you know
        where your request falls in the range of success to failure. From a high level common response codes fall into three possible categories, any in the <span
        className="bold">2xx range indicate success</span>, any in the <span className="bold">4xx range indicate an error has occurred in the request</span> and <span
        className="bold">5xx range indicate an error on the server side</span>.
      </p>

{/*-----------Authentication------------------------ */}

      <hr className="full-hr"></hr>

      <h1 className="introduction-header">Authentication Reference</h1>
      <div className="targetHelper" id="authentication"></div>
      <hr className="short-hr"></hr>

      <h1 className='sub-introduction-header'>Scope</h1>
      <p className="introduction-p">
      This section talks about end-to-end user identification, authentication, and API access authorization.
      </p>
      <img className='documentation-images' alt="authentication" src={auth} />
      <h1 className='sub-introduction-header'>High-level View</h1>
      <p className="introduction-p">
        Newforma.Cloud is a service that needs to access user's resources when the user is actively interacting with the platform via an application, and when the user is offline.
        This implies that it needs to be able to perform operations on behalf of users.
        <br/>
        <br/>
        Newforma.Cloud does not perform its own user authentication. Instead, it relies on identity federation services and uses other well-known identity providers to authenticate
        its users. These identity providers include the entities Azure (for authenticating on-premise users in particular).
        <br/>
        <br/>
        It is important to understand that the user-facing authentication process is driven by the identity provider (IdP), not Newforma. We do not need the passwords, SMS tokens,
        MFA configurations etc. - this all happens between the user and the UI/backend of the identity provider. We only get the callback when the authentication is successfully
        completed or failed.
        <br/>
        <br/>
        A few design considerations:<br/><br/></p>
        <ul className="docs-ul">
          <li>Newforma.Cloud is built to support multiple IdPs for the future.</li>
          <li>We want the backend to be able to operate for as long as possible on behalf of a user without bothering the user too often to re-authenticate.</li>
          <li>We also want to follow the best practices and avoid storing any credentials or transferring them back and forth regularly.</li>
        </ul>
<p className="introduction-p">
        Our IdPs are OpenID Connect - based (OIDC). A successful authorization request against an OAuth2 endpoint can return us the id_token (needed by AWS internals) and either
        the authorization code or the refresh token + an access token.  Generally, the client application can acquire the code + id_token, then "log in" to Newforma.Cloud by passing
        both. We can return temporary AWS credentials using the id_token provided and acquire access and refresh tokens allowing the backend to call the resource provider for as
        long as refresh token is valid.
        <br/>
        <br/>
        The application will have to renew the id_token once the temporary credentials are expired. This is fine from the security point of view as we do need to re-validate the
        user's identity periodically anyway. Re-acquisition of id_token does not invalidate the access and refresh tokens used by Newforma.Cloud backend.

      </p>




{/*-----------Support------------------------ */}

        <hr className="full-hr"></hr>

        <h1 className="introduction-header">Support</h1>
        <div className="targetHelper" id="support"></div>
        <p className="introduction-p-italic">
        Did you press the any key?
        </p>
        <hr className="short-hr"></hr>

        <p className="introduction-p">
        Newforma's Support team is here to help, if you have any questions, ideas or issues please reach out to us:
        <br/>
<br/></p>
        <ul className="docs-ul">
          <li><a href="mailto:nsellers@newforma.com?Subject=Portal%20Slack%20Request" target="_top">Let us know you want to join</a> our Slack channel to chat with us and other Newforma API experts. </li>
          <li>Visit the world renowned <a href="http://www.stackoverflow.com">Stack Overflow</a> to post a question and tag your post with "newforma-api".</li>
          <li>Reach out to us at Newforma directly by emailing support@newforma.com</li>
        </ul>
<p className="introduction-p">
        We monitor both our Slack Channel and Stack Overflow as closely as possible and will do our best to reach back out.
        </p>


{/*-----------Features------------------------ */}

        <hr className="full-hr"></hr>

        <h1 className="introduction-header">Features</h1>
        <div className="targetHelper" id="features"></div>

        <hr className="short-hr"></hr>

        <p className="introduction-p">
        The Newforma Project Center APIs are broken down into two categories:
        <br/>
<br/>
</p>
        <ul className="docs-ul">
          <li>Newforma Enterprise resources for on premise servers.</li>
          <li>Newforma Web/Mobile resources spanning both Cloud and on premises.</li>
        </ul>


        <p className="introduction-p">
        The Newforma ContructEx APIs contain one category:
        <br/>
<br/></p>
        <ul className="docs-ul">
          <li>Newforma ConstructEx APIs v1.0.</li>

        </ul>
<p className="introduction-p">
        The following section details all of the functionality and features of each specific resource.

      </p>
    <h1 className='sub-introduction-header'>Newforma Enterprise Resources</h1>

      <table className="api-features-table">
      <tbody>
        <tr>
          <th>Resouce</th>
          <th>Features</th>
        </tr>

        <tr>
          <td className="resource-td-width"><span className="api-features-table-endpoint"> Companies</span><br /> Manage your company records.</td>
          <td>
            <ul className="docs-ul">
              <li>Get the list of all companies.</li>
              <li>Get detailed data for a specified company.</li>
              <li>Update or delete multiple or individual company records.</li>
            </ul>
          </td>
        </tr>

        <tr>
          <td><span className="api-features-table-endpoint"> Company Office Locations</span><br /> Manage company contact office locations.</td>
          <td>
            <ul className="docs-ul">
              <li>Get the office locations for a specified company.</li>
              <li>Create an office location for a specified company.</li>
              <li>Get a specific office location.</li>
              <li>Update a specific office location.</li>
              <li>Delete a specific office location.</li>
            </ul>
          </td>
        </tr>

        <tr>
          <td><span className="api-features-table-endpoint"> Contacts</span><br /> Manage your contact records.</td>
          <td>
            <ul className="docs-ul">
              <li>Get a list of all your contacts.</li>
              <li>Create new contact records.</li>
              <li>Get a single contact record.</li>
              <li>Update your contact records.</li>
              <li>Delete contact records.</li>
            </ul>
          </td>
        </tr>

        <tr>
          <td><span className="api-features-table-endpoint"> Edms Plugins</span><br /> Retrieve available EDMS plugins.</td>
          <td>
            <ul className="docs-ul">
              <li>Get a list of all your available EDMS plugins.</li>
            </ul>
          </td>
        </tr>

        <tr>
          <td><span className="api-features-table-endpoint"> Health</span><br /> Check the health of your system.</td>
          <td>
            <ul className="docs-ul">
              <li>Get status of system health.</li>
            </ul>
          </td>
        </tr>

        <tr>
          <td><span className="api-features-table-endpoint"> KeywordListAssignments</span><br /> Retrieve your keyword list name for a specified keyword list type.</td>
          <td>
            <ul className="docs-ul">
              <li>Get keyword list name for specified list type and specified project.</li>
            </ul>
          </td>
        </tr>

        <tr>
          <td><span className="api-features-table-endpoint"> Keywords</span><br /> Retrieve a specified keyword list.</td>
          <td>
            <ul className="docs-ul">
              <li>Get a keyword list.</li>
            </ul>
          </td>
        </tr>

        <tr>
          <td><span className="api-features-table-endpoint"> Project Company Roles</span><br /> Manage your project company roles.</td>
          <td>
            <ul className="docs-ul">
              <li>Get company roles for a specified project.</li>
              <li>Get a specific company role.</li>
              <li>Create a company role for a specified project.</li>
              <li>Delete a company role.</li>
            </ul>
          </td>
        </tr>

        <tr>
          <td><span className="api-features-table-endpoint"> Project Folers</span><br /> Retrieve project folders.</td>
          <td>
            <ul className="docs-ul">
              <li>Get a list of project folders for a specified project.</li>
              </ul>
          </td>
        </tr>

        <tr>
          <td><span className="api-features-table-endpoint"> Project Company Roles</span><br /> Manage your project company roles.</td>
          <td>
            <ul className="docs-ul">
              <li>Get company roles for a specified project.</li>
              <li>Get a specific company role.</li>
              <li>Create a company role for a specified project.</li>
              <li>Delete a company role.</li>
            </ul>
          </td>
        </tr>



        <tr>
          <td><span className="api-features-table-endpoint"> Projects</span><br /> Gain access to high level project data.</td>
          <td>
            <ul className="docs-ul">
              <li>Get the list of projects.</li>
              <li>Get data for a specified project.</li>
              <li>Create new projects.</li>
              <li>Update your project records.</li>
              <li>Delete projects.</li>
            </ul>
          </td>
        </tr>

        <tr>
          <td><span className="api-features-table-endpoint"> Project Team Members</span><br /> Manage your project team records.</td>
          <td>
            <ul className="docs-ul">
              <li>Get a list of project team members for a specified project.</li>
              <li>Create a project team member.</li>
              <li>Get a single project team member's data for a specified project.</li>
              <li>Update project team member records.</li>
              <li>Delete project team members.</li>
            </ul>
          </td>
        </tr>

        <tr>
          <td><span className="api-features-table-endpoint"> Search</span><br /> Gain access for Newforma Search.</td>
          <td>
            <ul className="docs-ul">
              <li>Run a search against project(s).</li>
            </ul>
          </td>
        </tr>

        <tr>
          <td><span className="api-features-table-endpoint"> Submittals</span><br /> Manage submittals for a project.</td>
          <td>
            <ul className="docs-ul">
              <li>Get a list of project submittals.</li>
              <li>Get a specific project submittal.</li>
              <li>Create a pending or expected submittal within a specified project.</li>
            </ul>
          </td>
        </tr>

        <tr>
          <td><span className="api-features-table-endpoint"> Transmittals</span><br /> Get project transmittal details.</td>
          <td>
            <ul className="docs-ul">
              <li>Get transmittal details for a transmittal returned by the /Submittals endpoint.</li>
            </ul>
          </td>
        </tr>

        <tr>
          <td><span className="api-features-table-endpoint"> User</span><br /> Get user info for current Project Center user.</td>
          <td>
            <ul className="docs-ul">
              <li>Get contact information for the current Project Center user.</li>
            </ul>
          </td>
        </tr>

        <tr>
          <td><span className="api-features-table-endpoint"> Version</span><br /> Retrieve version for the server.</td>
          <td>
            <ul className="docs-ul">
              <li>Get server version.</li>

            </ul>
          </td>
        </tr>


        </tbody>

      </table>

      <h1 className='sub-introduction-header'>Newforma Web/Mobile Resources including NPCS and Cloud</h1>

      <table className="api-features-table">
      <tbody>
        <tr>
          <th>Resouce</th>
          <th>Features</th>
        </tr>

        <tr>
          <td className="resource-td-width"><span className="api-features-table-endpoint"> Action Items</span><br /> Keep your team members up to date with their action items, or get an overview of what the team is working on.</td>
          <td>
            <ul className="docs-ul">
              <li>Get the list of action items for the current user.</li>
              <li>Get open action items for a specified project.</li>
              <li>Create new action items.</li>
              <li>Add/Remove supporting documents to an existing action item.</li>
              <li>Get a specific action item.</li>
              <li>Get discussion items.</li>
              <li>Update an existing action item.</li>
              <li>Delete an existing action item.</li>
            </ul>
          </td>
        </tr>

        <tr>
          <td><span className="api-features-table-endpoint"> Files</span><br /> Manage your project files.</td>
          <td>
            <ul className="docs-ul">
              <li>Get the contents of a specificed project folder.</li>
              <li>Delete a project folder.</li>
            </ul>
          </td>
        </tr>

        <tr>
          <td><span className="api-features-table-endpoint"> File Upload</span><br /> Extend your file management by adding upload capability.</td>
          <td>
            <ul className="docs-ul">
              <li>Upload a file to a project folder.</li>
              <li>Delete an upload session.</li>
              <li>Update an upload session.</li>
            </ul>
          </td>
        </tr>

        <tr>
          <td><span className="api-features-table-endpoint"> Folders</span><br /> Manage your project folders.</td>
          <td>
            <ul className="docs-ul">
              <li>Create a project folder for a specified project and add contents to the new folder.</li>

            </ul>
          </td>
        </tr>

        <tr>
          <td><span className="api-features-table-endpoint"> Projects</span><br /> Manage your Newforma Cloud and NPC projects.</td>
          <td>
            <ul className="docs-ul">
              <li>Retrieve the My Projects list for a specified user.</li>
              <li>Retrieve a project folder for a specified project.</li>
              <li>Retrieve project team for a specified project.</li>
            </ul>
          </td>
        </tr>

        <tr>
          <td><span className="api-features-table-endpoint"> User</span><br /> Get info for a specified user.</td>
          <td>
            <ul className="docs-ul">
              <li>Retrieve contact information for the current Project Center user.</li>
            </ul>
          </td>
        </tr>
        </tbody>
      </table>


{/*ContructEx*/}

      {isAuthorized() ? ( <div> <br/><h1 className='sub-introduction-header'>Newforma ContructEx</h1>

      <table className="api-features-table">
      <tbody>
        <tr>
          <th>Resouce</th>
          <th>Features</th>
        </tr>

        <tr>
          <td className="resource-td-width"><span className="api-features-table-endpoint"> Auth Tokens</span><br /> Provides what you will need to authenticate to ContructEx APIs.</td>
          <td>
            <ul className="docs-ul">
              <li>Returns an Authorization Token that will be used to call all other ContructEx endpoints.</li>
            </ul>
          </td>
        </tr>

        <tr>
          <td><span className="api-features-table-endpoint"> Projects</span><br /> Discover your projects.</td>
          <td>
            <ul className="docs-ul">
              <li>Get a list of projects linked to the account.</li>
              <li>Get a list of roles in a specified project.</li>
              <li>Get a list of users in a specified project.</li>
            </ul>
          </td>
        </tr>

        <tr>
          <td><span className="api-features-table-endpoint"> Submittals</span><br /> Push and pull submittals to and from ConstructEx.</td>
          <td>
            <ul className="docs-ul">
              <li>Get a list of submittal trade/disciplines for a specified project.</li>
              <li>Get a list of submittal categories for a specified project.</li>
              <li>Get a list of submittal types for a specified project.</li>
              <li>Get a list of submittals form a specified date range for a specified project.</li>
              <li>Get submittal details of a specified submittal from a speicified project.</li>
              <li>Update a specified submittal within a specified project.</li>
              <li>Create a new submittal in a specified project.</li>
              <li>Update an existing submittal id.</li>
            </ul>
          </td>
        </tr>

</tbody>

      </table> </div>) : ''}
{/*-----------Nomenclature------------------------ */}

              <hr className="full-hr"></hr>

              <h1 className="introduction-header" >Conventions</h1>
              <div className="targetHelper" id="nomenclature"></div>

              <hr className="short-hr"></hr>

              <p className='sub-introduction-header'>Common Terms Explained</p>

                <table className="api-nomenclature-table">
                <tbody>
                  <tr>
                    <th>Term</th>
                    <th>Defintion</th>
                    <th>Example</th>
                  </tr>
                  <tr>
                    <td className="resource-td-width">NRN</td>
                    <td className="aLittleSpace">
                      Newforma Resource Names are used to identify entities inside our database or in an external data source (NPC, Cloud Storage etc.). These are similar
                        to Amazon's ARN(Amazon Resource Name).
                    </td>
                    <td>
                      "nrn:npc:project:13b7a6t9-m8a9-n342-8391-017cae2c1a16::PROJNAME:e423e2x8-a4m8-p6l3-e77b-cccb14cbdb10"
                    </td>
                  </tr>


                  <tr>
                    <td className="resource-td-width">Record</td>
                    <td>
                      An individual data item with a unique identifier.
                    </td>
                  <td>
                    A project team contact.
                  </td>
                  </tr>


                  <tr>
                    <td className="resource-td-width">Attribute</td>
                    <td>
                      A Key - Value pair in a record.
                    </td>
                  <td>
                    Name: "Building Project"
                  </td>
                  </tr>


                  <tr>
                    <td className="resource-td-width">Endpoint</td>
                    <td>
                      A reference to an API method or URI that accepts web requests.
                    </td>
                  <td>
                    GET /actionitems
                  </td>
                  </tr>

                  <tr>
                    <td className="resource-td-width">Resource</td>
                    <td>
                      An object or set of objects that are exposed at an API endpoint, typically displayed in JSON format.
                    </td>
                  <td>
                    <span className="italic">&#123;"projects":[&#123;"id":"5ef3db2d-a7da-3a5f-4de3-6748ed35e608","name":"Building Project","number":"1234.01","npcServer":"NPCS_ServerName"&#125;,&#123;"id"...</span>
                  </td>
                  </tr>

                  <tr>
                    <td className="resource-td-width">JSON</td>
                    <td>
                      JavaScript Object Notation is a lightweight data-interchange format. It is easy for humans to read and write and easy for machines to parse and generate.
                    </td>
                  <td>
                    <span className="italic">&#123;"projects":[&#123;"id":"5ef3db2d-a7da-3a5f-4de3-6748ed35e608","name":"Building Project","number":"1234.01","npcServer":"NPCS_ServerName"&#125;,&#123;"id"...</span>
                  </td>
                  </tr>

                  <tr>
                    <td className="resource-td-width">URI</td>
                    <td>
                     A Uniform Resource Identifier is a string of characters designed for unambiguous identification or resources
                    </td>
                  <td>
                    A URL is a type of URI.
                  </td>
                  </tr>

                  <tr>
                    <td className="resource-td-width">Parameter</td>
                    <td>
                      A variable value passed to an endpoint.
                    </td>
                  <td>
                    /projects/&#123;projectId&#123;/actionitems requires a Project ID parameter.
                  </td>
                  </tr>
                  </tbody>
                </table>

</div>




      {/*</div>*/}
      </div>

    </div> )
}
}



/** WEBPACK FOOTER **
 ** ./src/pages/Documentation/index.js
 **/